<script>
    export default {
        props: {
            filter: {
                type: Object,
                default: {}
            },
            filterKey: {
                type: String
            },
            buttons: {
                type: Array
            },
            defaultValue: {
                default: () => { return NaN; }
            }
        },
        computed: {
            value() {
                if (_.has(this.filter, this.filterKey)) {
                    return this.filter[this.filterKey];
                }

                return this.defaultValue;
            },
        },
        methods: {
            setValue(value) {
                this.$parent.$emit('set-value', this.filterKey, value);
            },
        }
    }
</script>

<template>
    <div class="attribute-translation-filter">
        <div class="btn-group btn-group-sm m-t-sm" role="group" aria-label="Filter">
            <template v-for="button in buttons">
                <a @click="setValue(button.value)"
                   :class="['btn btn-w-m', value == button.value ? 'btn-primary' : 'btn-default']">
                    <span v-text="button.label"></span>
                </a>
            </template>
        </div>
    </div>
</template>